exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#item-candidate-invite .div-progress, #div_cv .div-progress{\n  height: 8px;\n  width: 100%;\n  background-color: #ccc;\n  border-radius: 20px;\n}\n\n#item-candidate-invite .div-child-progress, #div_cv .div-child-progress{\n  height: 8px;\n  border-radius: 20px;\n}\n\n#item-candidate-invite .prg-1, #div_cv .prg-1{\n  background-color:#00d38f;\n}\n\n#item-candidate-invite .prg-2, #div_cv .prg-2{\n  background-color:#0099d3;\n}\n\n#item-candidate-invite .prg-3, #div_cv .prg-3{\n  background-color:#ebc000;\n}\n\n#item-candidate-invite .prg-4, #div_cv .prg-4{\n  background-color:#ff534f;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/item-candidate/item-candidate.component.css
// module id = ../../../../../src/app/pages/item-candidate/item-candidate.component.css
// module chunks = main